/** Impl dos use cases de aprovação de Documento. @since G.5.2 */
import type { Documento } from '@/domain/model/Documento';
import type { Page } from '@/domain/model/Page';
import type {
  DocumentoAprovacaoGateway, ListFilaValidacaoParams,
  AprovarDocumentoCommand, NegarDocumentoCommand,
} from '@/application/port/out/DocumentoAprovacaoGateway';
import type {
  ListFilaValidacaoUseCase, AprovarDocumentoUseCase,
  NegarDocumentoUseCase, PedirComplementacaoDocumentoUseCase,
} from '@/application/port/in/DocumentoAprovacaoUseCase';

export class ListFilaValidacao implements ListFilaValidacaoUseCase {
  constructor(private readonly g: DocumentoAprovacaoGateway) {}
  execute(params: ListFilaValidacaoParams): Promise<Page<Documento>> { return this.g.listFila(params); }
}
export class AprovarDocumento implements AprovarDocumentoUseCase {
  constructor(private readonly g: DocumentoAprovacaoGateway) {}
  execute(id: string, cmd: AprovarDocumentoCommand): Promise<Documento> { return this.g.aprovar(id, cmd); }
}
export class NegarDocumento implements NegarDocumentoUseCase {
  constructor(private readonly g: DocumentoAprovacaoGateway) {}
  execute(id: string, cmd: NegarDocumentoCommand): Promise<Documento> { return this.g.negar(id, cmd); }
}
export class PedirComplementacaoDocumento implements PedirComplementacaoDocumentoUseCase {
  constructor(private readonly g: DocumentoAprovacaoGateway) {}
  execute(id: string, cmd: NegarDocumentoCommand): Promise<Documento> { return this.g.pedirComplementacao(id, cmd); }
}
